var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fabButton"},[_c('ovp-button',_vm._g({staticClass:"button",class:{
    'is-tiny': _vm.hasScrolled,
    'has-gap': _vm.scrolledToBottom,
    'hide': _vm.isVirtualKeyboardShown
    },attrs:{"secondary":""}},_vm.$listeners),[_c('span',{staticClass:"button__text",domProps:{"textContent":_vm._s(_vm.$t('fab.button'))}}),_c('ovp-icon',{staticClass:"button__icon",attrs:{"art":"light","name":_vm.icon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }